// Function loadNearbyStores loads the NearbyStores class by dynamically importing the js on demand if needed

export function loadNearbyStores($parentEl, isList = false) {
	let $blk = $parentEl.querySelector('[data-blk="NearbyStores"]');

	if (!$blk) {
		// console.info('NearbyStores: no widget found');
		return Promise.reject('NearbyStores block not found in the parent element');
	}

	return import(/* webpackChunkName: "blk-nearby-stores-chunk" */ './nearbyStores').then((blk) => {
		const {NearbyStores} = blk;


		if (isList) {
			let $blkCol = $parentEl.querySelectorAll('[data-blk="NearbyStores"]');
			let instances = [];
			Array.from($blkCol).forEach(($blk, i) => {
				instances.push( new NearbyStores($blk) );
			});
			if (instances.length === $blkCol.length) return instances;
		} else {
			return new NearbyStores($blk);
		}
	}).catch((error) => error+'An error occurred while loading the NearbyStores widget');
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/blocks/nearbyStores/js/loadBlk.js